if (document.querySelector('.terms-link')) {
  const termsLinks = document.querySelectorAll('.terms-link')
  const termsPopup = document.querySelector('.terms-popup')
  const termsOverlay = document.querySelector('.terms-overlay')
  const termsClose = document.querySelector('.terms-close')
  const termsCloseBtn = document.querySelector('.terms-close-btn')
  var termsPopupContent = ''
  termsLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault()
      e.stopPropagation()
      termsPopupContent = e.target.dataset.termsContent
      termsPopup.classList.add('show')
      document.querySelector('.' + termsPopupContent + '-content').classList.add('show')
    }, false)
  })
  termsOverlay.addEventListener('click', (e) => {
    removePopup(e, termsPopup)
  }, false)
  termsClose.addEventListener('click', (e) => {
    removePopup(e, termsPopup)
  })
  termsCloseBtn.addEventListener('click', (e) => {
    removePopup(e, termsPopup)
  })
}

function removePopup(e, termsPopup) {
  e.preventDefault()
  e.stopPropagation()
  termsPopup.classList.remove('show')
  document.querySelector('.' + termsPopupContent + '-content').classList.remove('show')
  termsPopupContent = ''
}
